import { useState, useRef, useEffect, useContext } from 'react';
import { User, Ticket, Info, LogOut } from 'lucide-react';
import { StyledUserMenu, UserIcon, MenuDropdown, MenuItem, Divider, UserGreeting } from './styled';
import { AuthContext, GlobalComponentsContext } from 'context';
import { URLS } from 'constants/urls';
import { useHistory } from 'react-router-dom';
import * as Sentry from '@sentry/react';
export const UserMenu = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const { authContext } = useContext(AuthContext);
  const { user } = authContext;
  const history = useHistory();
  const { globalComponentsContext, setGlobalComponentsContext } = useContext(GlobalComponentsContext);

  const logout = () => {
    Sentry.captureMessage('[logout] user menu', {
      level: 'info',
    });
    history.push('/logout');
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    const handleClickOutside = event => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <StyledUserMenu ref={menuRef}>
      <UserGreeting onClick={toggleMenu}>
        Olá, <span>{user?.name || 'usuário leankeep'}</span>
        <UserIcon onClick={toggleMenu}>
          <User size={18} />
        </UserIcon>
      </UserGreeting>
      <MenuDropdown isOpen={isMenuOpen}>
        <MenuItem href={URLS.account}>
          <User size={16} />
          Minha Conta
        </MenuItem>
        <MenuItem href={URLS.tickets}>
          <Ticket size={16} />
          Meus Tickets
        </MenuItem>
        <Divider />
        <MenuItem
          onClick={() =>
            setGlobalComponentsContext({
              ...globalComponentsContext,
              isMobileMenuOpen: true,
            })
          }
          onKeyPress={() =>
            setGlobalComponentsContext({
              ...globalComponentsContext,
              isMobileMenuOpen: true,
            })
          }
        >
          <Info size={16} />
          Sobre
        </MenuItem>
        <MenuItem onClick={() => logout()}>
          <LogOut size={16} />
          Sair
        </MenuItem>
      </MenuDropdown>
    </StyledUserMenu>
  );
};
